import { Card } from "antd";
import { IdentitiesBoard } from "../../components/Identities/IdentitiesBoard";

export const IdentitiesPage = () => {
  return (
    <Card className="w-full">
      <IdentitiesBoard variant="partner" />
    </Card>
  );
};
